export default __webpack_public_path__ + "static/media/calendar.54ccd264.svg";